module.exports = __webpack_public_path__ + "static/media/041.2944e280.png";